export default [
  [
    {
      id: 'refId',
      type: 9,
      span: 4,
      offset: 0,
      props: { width: '100%', title: { text: 'Ref ID' } },
    }, {
      id: 'customerRefId',
      type: 0,
      span: 4,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'Customer Ref Id *' } },
    }, {
      id: 'revenueRecordDate',
      type: 2,
      span: 4,
      offset: 0,
      dataType: 'date',
      props: { padding: '8px 0', width: '100%', title: { text: 'วันที่รับรู้รายได้ *' } },
    }, {
      id: 'createdDate',
      type: 2,
      span: 4,
      offset: 0,
      dataType: 'date',
      props: { padding: '8px 0', width: '100%', title: { text: 'วันที่สร้าง *' } },
    }, {
      id: 'dueDate',
      type: 2,
      span: 4,
      offset: 0,
      dataType: 'date',
      props: { padding: '8px 0', width: '100%', title: { text: 'วันที่ครบกำหนดชำระ *' } },
    }, {
      id: 'dealType',
      type: 9,
      span: 4,
      offset: 0,
      props: { width: '100%', title: { text: 'ประเภทสัญญางาน' } },
    },
  ], [
    {
      id: 'companyName',
      type: 1,
      span: 12,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ผู้จ้าง' } },
    }, {
      id: 'credit',
      type: 11,
      span: 12,
      offset: 0,
      unit: 'วัน',
      props: { padding: '8px 0', width: '100%', title: { text: 'เครดิต' } },
    },
  ], [
    {
      id: 'cargo',
      type: 10,
      span: 6,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ประเภทสินค้า' } },
    }, {
      id: 'contractWeight',
      type: 12,
      span: 6,
      offset: 0,
      unit: 'ตัน',
      props: { padding: '8px 0', width: '100%', title: { text: 'น้ำหนัก/เที่ยวทั้งหมดในสัญญา' } },
    }, {
      id: 'deliveredWeight',
      type: 10,
      span: 6,
      offset: 0,
      unit: 'ตัน',
      props: { padding: '8px 0', width: '100%', title: { text: 'น้ำหนัก/เที่ยวที่ขนส่งแล้ว' } },
    },
  ], [
    {
      id: 'shippingCount',
      type: 10,
      span: 6,
      offset: 0,
      unit: 'เที่ยว',
      props: { padding: '8px 0', width: '100%', title: { text: 'รวมจำนวน' } },
    }, {
      id: 'totalWeight',
      type: 10,
      span: 18,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'น้ำหนักทั้งหมด' } },
    }, {
      id: 'pricePerLitre',
      type: 13.1,
      span: 6,
      offset: 0,
      unit: 'บาทต่อลิตร',
      props: {
        padding: '8px 0', width: '50%', margin: '0 16px 0 0', title: { text: 'ราคาน้ำมัน' },
      },
    }, {
      id: 'feeRate',
      type: 13.2,
      span: 6,
      offset: 0,
      unit: 'บาท',
      props: {
        padding: '8px 0', width: '50%', margin: '0 16px 0 0', title: { text: 'อัตราค่าขนส่ง' },
      },
    }, {
      id: 'shippingGrandTotal',
      type: 10,
      span: 3,
      offset: 0,
      unit: 'บาท',
      props: { padding: '8px 0', width: '100%', title: { text: 'ค่าขนส่งรวม' } },
    }, {
      id: 'isUpdateFeeRate',
      type: 14,
      span: 6,
      offset: 0,
      unit: 'บาท',
      props: { padding: '8px 0', width: '100%' },
    },
  ], [
    {
      label: 'หมายเหตุ',
      id: 'remark',
      span: 12,
      type: 8,
      props: { rows: 4 },
    },
  ], [
    {
      label: 'อัพโหลด',
      id: 'files',
      span: 12,
      type: 5,
      offset: 0,
      props: { rows: 4 },
    },
  ],
]
